// removed by extract-text-webpack-plugin
module.exports = {"iconWrapper":"index__iconWrapper___NhzOk","active":"index__active___1Y3Kf","icon":"index__icon___PJaTQ","disabled":"index__disabled___1fpGr","folder":"index__folder___ql5zH","title":"index__title___1UKLY","reportsContainer":"index__reportsContainer___1XamE","visible":"index__visible___5ysWL","dragWrapper":"index__dragWrapper___ijMO0"};


//////////////////
// WEBPACK FOOTER
// ./src/views/DashboardSettings/components/index.less
// module id = 216
// module chunks = 3